<template>
    <div class="main">
        <div class="upload-section" @drop.prevent="handleDrop" @dragover.prevent @click="triggerFileSelect">
            <input ref="fileInput" type="file" class="hidden" multiple @change="handleFileChange" />
            <div class="upload-content">
                <div class="icon-con">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M6.6665 13.3333L9.99984 10M9.99984 10L13.3332 13.3333M9.99984 10V17.5M16.6665 13.9524C17.6844 13.1117 18.3332 11.8399 18.3332 10.4167C18.3332 7.88536 16.2811 5.83333 13.7498 5.83333C13.5677 5.83333 13.3974 5.73833 13.3049 5.58145C12.2182 3.73736 10.2119 2.5 7.9165 2.5C4.46472 2.5 1.6665 5.29822 1.6665 8.75C1.6665 10.4718 2.36271 12.0309 3.48896 13.1613"
                            stroke="#535862" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="upload-text">
                    <div class="upload-instruct">
                        <span>Click to Upload</span>
                        <p>or Drag and Drop</p>
                    </div>
                    <p class="file-details">SVG, PNG, JPG or GIF (max. 800x400px)</p>
                </div>
            </div>
        </div>
        <UploadFileQueue v-if="store.uploads.length > 0" :uploads="store.uploads" @delete="handleDelete" />
    </div>
</template>
<script setup lang="ts">
import { useContactsTempStore } from '~/stores/person/contacts-temp';
import UploadFileQueue from './UploadFileQueue.vue';
const store = useContactsTempStore();
const fileInput = ref<HTMLInputElement | null>(null);

const triggerFileSelect = () => {
    (fileInput.value as HTMLInputElement)?.click();
};

const handleFileChange = (e: Event) => {
    processFiles((e.target as HTMLInputElement).files || new FileList());
};

const handleDrop = (e: DragEvent) => {
    processFiles(e.dataTransfer?.files || new FileList());
};

const processFiles = (files: FileList) => {
    Array.from(files).forEach((file) => {
        const uploadItem = {
            name: file.name,
            size: (file.size / 1024).toFixed(2) + ' KB',
            progress: 0,
        };
        store.uploads.push(uploadItem);
        simulateUpload(uploadItem);
    });
};

const simulateUpload = (file: { progress: number }) => {
    const interval = setInterval(() => {
        if (file.progress >= 100) {
            clearInterval(interval);
        } else {
            file.progress = Math.min(file.progress + 5, 100);
            store.uploads = [...store.uploads];
        }
    }, 200);
};

const handleDelete = (index: number) => {
    store.uploads.splice(index, 1)
}
</script>
<style lang="scss" scoped>
.main {
    @apply flex flex-col items-start gap-5 px-6 self-stretch;

    .upload-section {
        @apply cursor-pointer flex flex-col items-center gap-1 px-6 py-4 self-stretch rounded-[12px] border-2 border-[#E9EAEB] bg-[#ffffff];

        &:hover {
            border: 2px solid #155eef;
        }

        .upload-content {
            @apply flex flex-col items-center gap-3 self-stretch;

            .icon-con {
                @apply rounded-[8px] border border-[#E9EAEB] bg-[#FFF] flex w-[40px] h-[40px] p-[10px] justify-center items-center;
                @apply shadow-[inset_0px_0px_0px_1px_rgba(10,13,18,0.18),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05),0px_1px_2px_0px_rgba(16,24,40,0.05)];
            }

            .upload-text {
                @apply flex flex-col items-center gap-1 self-stretch;

                .upload-instruct {
                    @apply flex justify-center items-start gap-1 self-stretch;

                    span {
                        @apply text-[#155eef] font-inter text-sm font-semibold leading-5 cursor-pointer;
                    }

                    p {
                        @apply text-[#535862] font-inter text-sm font-normal leading-5;
                    }
                }

                .file-details {
                    @apply text-[#535862] text-center font-inter text-xs font-normal leading-4;
                }
            }
        }
    }
}
</style>
